import CustomerForm from './CustomerForm'

const CreateCustomer = () => {
    return (
        <CustomerForm customer={{
            id: 0,
            documents: [],
            contacts: [],
            defaultCurrencyId: undefined,
            disabled: false,
            address: { address1: '', address2: '', address3: '', city: '', state: '', postalCode: '' },
        }} isDisabled={false} />
    )
}

export default CreateCustomer
